<template lang='pug'>
//- 諮詢顧問介紹
div(:class='$style[`cc-popbox-vendor`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-popbox-vendor-type`]')
    div(:class='$style[`cc-vendor`]')
      div(:class='$style[`cc-vendor-avatar`]')
        figure(:class='$style[`cc-vendor-photo`]')
          img(
            :src='avatarSrcLink(detail.thumbSrc)'
            width='100%'
            height='100%')

      div(:class='$style[`cc-popbox-vendor-title`]')
        span.font-bold(:class='$style[`cc-popbox-vendor-main-title`]') {{ detail.name }}
        span.font-medium(:class='$style[`cc-popbox-vendor-sub-title`]') {{ detail.intro }}

        div(v-if='detail.web || detail.facebook || detail.youtube' :class='$style[`cc-vendor-block-panel`]')
          a.btn-extra(
            v-if='detail.web'
            :class='$style[`cc-vendor-block-panel-link`]'
            tabindex='0' aria-label='網站介紹'
            :href='detail.web'
            target='_blank')
            IconLink(:size='22' :color='`#b1b1b1`')
            span 網站介紹
          a.btn-extra(
            v-if='detail.facebook'
            :class='$style[`cc-vendor-block-panel-link`]'
            tabindex='0' aria-label='FB粉專'
            :href='detail.facebook'
            target='_blank')
            IconFacebook(:size='22')
            span FB粉專
          a.btn-extra(
            v-if='detail.youtube'
            :class='$style[`cc-vendor-block-panel-link`]'
            tabindex='0' aria-label='YouTube頻道'
            :href='detail.youtube'
            target='_blank')
            IconYoutube(:size='22')
            span YouTube頻道

      div(:class='$style[`cc-vendor-container`]')
        div(v-if="detail.vendor_id === 0 || detail.vendor_id === '0'" :class='$style[`cc-vendor-block`]')
          header.font-bold(:class='$style[`cc-vendor-block-title`]') 關於Dr.Cell
          div(:class='$style[`cc-vendor-block-info`]')
            span 「Dr.Cell AI」為健細胞科技與多位癌症腫瘤醫師共同研發訓練的「癌症整合醫學」多模態AI模型（LMM），除了提供生成式對話之外，亦是ePRO數據分析、生成近況報告、嚴重化偵測篩選、醫療報告解說、飲食照片分析、主動式通報 功能的核心技術。Cancell協助病患蒐集數據、管理數據、有效利用數據，成為醫病遠距照護的強大輔助工具，讓病患使用AI變得極簡單。 「Dr.Cell AI」(RAG)增強檢索與(Distill)訓練資料包含 :
            ul
              li 美國 NCCN 全癌症治療準則
              li 台灣衛服部健保藥物、健康與保健食品開源資料
              li Hugging Face (Pubmed)系列經篩選資料集
              li 癌康網整合醫學、輔助醫學專欄文章
              li 所有 Cancell 醫病去識別化真實對話記錄
              li 所有 Cancell 線上課程與單元

        div(v-else-if='detail.vendor_id === 1' :class='$style[`cc-vendor-block`]')
          header.font-bold(:class='$style[`cc-vendor-block-title`]') 公益諮詢簡介
          div(:class='$style[`cc-vendor-block-info`]')
            span 「Cancell 醫抗癌」提供線上公益諮詢服務，廖志穎醫師專長領域包含: 高階質子治療、整合性低副作用放射治療（乳、頭頸、肺、攝護腺、直腸、肝、食道等）、免疫多醣體白血球營養、高劑量維他命C/甘草甜素、化療手麻腳麻、癌疲憊、抗發炎調理、循環癌細胞CTC/MDSC/腸道基因檢測等。幫助預防復發，增加治療生活品質與成功率。
            ul
              li 中國附醫放射腫瘤部醫師
              li 前部立台中醫院放射腫瘤科主任
              li 紐約史隆凱特琳醫院整合腫瘤醫學
              li 休士頓安德森癌症中心整合醫學

        div(v-else-if='detail.vendor_id === 2' :class='$style[`cc-vendor-block`]')
          header.font-bold(:class='$style[`cc-vendor-block-title`]') 公益諮詢簡介
          div(:class='$style[`cc-vendor-block-info`]')
            span 「Cancell 醫抗癌」提供線上公益諮詢服務，黃曉薇營養師專長領域包含: 癌症營養、樂齡營養、新陳代謝疾病（糖尿病、腎臟病、高血脂、高血壓、痛風、甲狀腺疾病），飲食質地調整、管灌飲食等，幫助癌友補充治療所需的各項營養素，預防轉移復發並增加治療成功率。
            ul
              li 前台中榮總癌症中心營養師
              li 癌康網營養總顧問
              li 臺灣高齡照護發展學會 營養顧問
              li 國立暨南國際大學 兼任講師

        div(v-if='detail.vendor_id !== 0' :class='$style[`cc-vendor-block`]')
          header.font-bold(:class='$style[`cc-vendor-block-title`]') 醫護團隊成員
          div(:class='$style[`cc-vendor-block-info`]')
            ul(:class='$style[`cc-vendor-block-member`]')
              li(v-for='(items, index) in detail.member' :class='$style[`cc-vendor-block-member-li`]')
                div(v-if='items.user_type === `doctor`' :class='$style[`cc-vendor-block-member-left`]')
                  figure(v-if='!items.thumbSrc' :class='$style[`cc-vendor-block-member-left-photo`]')
                    //- Doctor-Male-Avatar
                    img(
                      v-if='items.gender === `0`'
                      :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                      width='100%'
                      height='100%')
                    //- Doctor-Female-Avatar
                    img(
                      v-else
                      :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                      width='100%'
                      height='100%')

                  figure(v-else :class='$style[`cc-vendor-block-member-left-photo`]')
                    img(
                      :src='avatarSrcLink(items.thumbSrc)'
                      width='100%'
                      height='100%')

                div(v-else-if='items.user_type === `normal`' :class='$style[`cc-vendor-block-member-left`]')
                  figure(v-if='items.thumbSrc' :class='$style[`cc-vendor-block-member-left-photo`]')
                    img(
                      :src='avatarSrcLink(items.thumbSrc)'
                      width='100%'
                      height='100%')

                  figure(v-else :class='$style[`cc-vendor-block-member-left-photo`]')
                    img(
                      v-if='items.gender === `0`'
                      :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                      width='100%'
                      height='100%')
                    img(
                      v-else
                      :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                      width='100%'
                      height='100%')

                div(v-if='items.user_type === `doctor`' :class='$style[`cc-vendor-block-member-right`]')
                  div(:class='$style[`cc-vendor-block-member-right-name`]')
                    span.font-bold.font-doctor-theme {{ items.first_name }}{{ items.last_name }}
                  div(:class='$style[`cc-vendor-block-member-right-intro`]') {{ items.character }}
                div(v-else :class='$style[`cc-vendor-block-member-right`]')
                  div(:class='$style[`cc-vendor-block-member-right-name`]')
                    span.font-bold.font-normal-theme {{ items.first_name }}{{ items.last_name }}
                  div(:class='$style[`cc-vendor-block-member-right-intro`]') 一般會員

              //- Dr.Cell AI醫生
              li(:class='$style[`cc-vendor-block-member-li`]')
                div(:class='$style[`cc-vendor-block-member-left`]')
                  figure(:class='$style[`cc-vendor-block-member-left-photo`]')
                    img(
                      :src='avatarSrcLink("userAvatar/doctor108_1628770059459.webp")'
                      width='100%'
                      height='100%')

                div(:class='$style[`cc-vendor-block-member-right`]')
                  div(:class='$style[`cc-vendor-block-member-right-name`]')
                    span.font-bold.font-doctor-theme Dr.Cell
                  div(:class='$style[`cc-vendor-block-member-right-intro`]') AI醫生

  div(:class='$style[`cc-vendor-controller`]')
    button.btn-extra.font-medium(
      aria-label='知道了'
      tabindex='0'
      :class='$style[`cc-vendor-controller-btn`]'
      @click='handleClosePopBox') 知道了
    //- button.btn-extra.font-medium(
    //-   aria-label='不再顯示'
    //-   tabindex='0'
    //-   :class='$style[`cc-vendor-controller-btn`]'
    //-   @click='handleClickToClose') 不再顯示

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// import IconCcoin from '../../icon/Ccoin';
import IconLink from '../../icon/Link';
import IconFacebook from '../../icon/Facebook';
import IconYoutube from '../../icon/Youtube';
// import {
//   putChatUpdateRoomRead,
// } from '../../../js/restapi';

export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },

  components: {
    // IconCcoin,
    IconLink,
    IconFacebook,
    IconYoutube,
  },

  // data() {
  //   return {};
  // },

  methods: {
    ...mapMutations({
      changePopVendorProfileStatus: 'global/POPVENDORPROFILE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopVendorProfileStatus({
        active: false,
        detail: {},
      });
    },

    // handleClickToClose() {
    //   putChatUpdateRoomRead('', {
    //     room_name: `${this.detail.vendor_id}-${this.loginHashCode}-${this.loginDjangoId}`,
    //   })
    //     .then((res) => {
    //       console.log('update room read');
    //       this.handleClosePopBox();
    //     })
    //     .catch((err) => {
    //       console.log('error');
    //     });
    // },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popConsultVendor.scss';
</style>
